import {
    close_icon,
    verified_icon,
    verified_icon_mobile,
} from './module_svg_icons';

const messageNotyIconWrapClass = "icon-wrap"
const messageNotyTextClass = "alert-texts"
const messageNotyClickableSelector = ".alert ."+messageNotyIconWrapClass+", .alert ."+messageNotyTextClass

const notifies = [];

// https://github.com/mouse0270/bootstrap-notify
const messageNoty = function (messageTop, messageDown, clickFunction) {
    let duration = 5000;
    const t="success";
    const icon = 'success';
    const classString = "<<customClass>>"
    const iconString = "<<customIcon>>"
    const temp = `
    <div 
        class="`+classString+` alert alert-{0} notification-container message-notify alert-game"
        data-notify="container"
        role="alert"
    >
        <div class="alert-box">
            <div data-notify="icon" class="`+messageNotyIconWrapClass+`">`+iconString+`</div>
            <div class="`+messageNotyTextClass+`">
                <p class="labelM-med firstRow" data-notify="title">{1}</p>
                <p class="labelM-med secondRow" data-notify="message">{2}</p>
            </div>
            <div class="close-wrap">
                <div aria-hidden="true" class="close" data-notify="dismiss">`+close_icon+`</div>
            </div>
        </div>
        
    </div>
    `

    let deskTemp = temp.replace(classString, "d-none d-md-block")
    deskTemp = deskTemp.replace(iconString, verified_icon)

    let mobileTemp = temp.replace(classString, "d-md-none")
    mobileTemp = mobileTemp.replace(iconString, verified_icon_mobile)
    
    const nDesk = $.notify({
        icon: icon,
        title: messageTop,
        message: messageDown,
    }, {
        delay: duration,
        z_index: 2147483657,
        type: t,
        allow_dismiss: true,
        placement: {
            from: "top",
            align: "right",
        },
        template: deskTemp,
        offset: {
            y: 104,
            x: 20,
        },
        onClosed: messageNotififyCloseAll
    });

    const nMobile = $.notify({
        icon: icon,
        title: messageTop,
        message: messageDown,
    }, {
        delay: duration,
        z_index: 2147483657,
        type: t,
        allow_dismiss: true,
        placement: {
            from: "bottom",
            align: "center",
        },
        template: mobileTemp,
        onClosed: messageNotififyCloseAll
    });
    notifies.push(nDesk, nMobile)
    $(messageNotyClickableSelector).click(clickFunction)
};

export const messageNotification = function (firstRow, secondRow, clickFunction) {
    messageNoty(firstRow, secondRow, clickFunction);
}

export const messageNotififyCloseAll = function(){
    notifies.forEach(element => {
        element.close()
    });
    notifies.length = 0;
}